/* SCREEN BREAKS */
.facebook-color {
  background: hsl(222deg, 47%, 40%) !important;
}

.twitter-color {
  background: hsl(198deg, 100%, 47%) !important;
}

.linkedin-color {
  background: hsl(198deg, 100%, 47%) !important;
}

.text-primary {
  color: #517fc4;
}

a.text-primary:hover,
a.text-primary:focus {
  color: #286090;
}

.text-success {
  color: #409b6c;
}

a.text-success:hover,
a.text-success:focus {
  color: #317753;
}

.text-info {
  color: #517fc4;
}

a.text-info:hover,
a.text-info:focus {
  color: #2c4f83;
}

.text-warning {
  color: #f26739;
}

a.text-warning:hover,
a.text-warning:focus {
  color: #e9450f;
}

.text-danger {
  color: #c45151;
}

a.text-danger:hover,
a.text-danger:focus {
  color: #a93939;
}

.bg-primary {
  color: #ffffff;
  background-color: #337ab7;
}

a.bg-primary:hover,
a.bg-primary:focus {
  background-color: #286090;
}

.bg-success {
  background-color: #dff0d8;
}

a.bg-success:hover,
a.bg-success:focus {
  background-color: #c1e2b3;
}

.bg-info {
  background-color: #d9edf7;
}

a.bg-info:hover,
a.bg-info:focus {
  background-color: #afd9ee;
}

.bg-warning {
  background-color: #fcf8e3;
}

a.bg-warning:hover,
a.bg-warning:focus {
  background-color: #f7ecb5;
}

.bg-danger {
  background-color: #f2dede;
}

a.bg-danger:hover,
a.bg-danger:focus {
  background-color: #e4b9b9;
}

.clearfix::after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

html.showpass-widget-body {
  overflow: visible !important;
}

html.showpass-widget-body,
html.showpass-widget-body body {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
  height: 100% !important;
}

html.showpass-widget-body body {
  overflow: hidden !important;
  position: fixed !important;
  top: 0;
}
@media screen and (max-width: 960px) {
  html.showpass-widget-body body {
    -webkit-overflow-scrolling: touch !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
@media screen and (-webkit-min-device-pixel-ratio: 1.5),
  screen and (-webkit-min-device-pixel-ratio: 2),
  screen and (-webkit-min-device-pixel-ratio: 3) {
  html.showpass-widget-body body {
    margin: 0 !important;
    padding: 0 !important;
  }
}

:-ms-fullscreen .showpass-widget-body .showpass-widget-wrapper,
:root .showpass-widget-body .showpass-widget-wrapper {
  background-size: 125px 31px !important;
}

@keyframes fadeIn {
  from {
    background-color: rgba(0, 0, 0, 0);
  }
  to {
    background-color: rgba(0, 0, 0, 0.45);
  }
}

@keyframes fadeOut {
  from {
    background-color: rgba(0, 0, 0, 0.45);
  }
  to {
    background-color: rgba(0, 0, 0, 0);
  }
}

.showpass-widget-wrapper {
  display: block;
  position: fixed;
  background-size: 100px 100px;
  background-position: center;
  background-repeat: no-repeat;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000000000;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.45);
  animation: fadeIn 0.3s ease-in-out;
}

.showpass-widget-wrapper.closing {
  animation: fadeOut 0.3s ease-in-out;
}

.showpass-widget-wrapper .showpass-widget-iframe {
  display: block;
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  min-height: 100%;
  min-width: 100%;
  max-height: 100%;
}

.showpass-widget-embedded-wrapper {
  background-size: 100px 100px;
  background-position: center;
  background-repeat: no-repeat;
}

.showpass-widget-embedded-wrapper .showpass-widget-iframe {
  display: block;
  border: 0;
  width: 100%;
  height: 100%;
}

.showpass-widget-iframe {
  min-height: 750px;
  /* Add smooth transition for height and opacity changes */
  transition: height 0.3s ease-out, min-height 0.3s ease-out, opacity 0.2s ease-out 0.2s;
  opacity: 1;
}

.showpass-is-loading {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="-20 -20 40 40"><style>circle { animation: 4s a infinite linear, 3s o infinite linear; }@keyframes a {from{stroke-dasharray:100 0}50%25{stroke-dasharray:0 100}to{stroke-dasharray:100 0}}@keyframes o {from{stroke-dashoffset:75}to{stroke-dashoffset:-225}}<%2Fstyle><circle r="15.9154943092" stroke-width="7" fill="none" stroke="snow" /></svg>');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 60px 60px;

  .showpass-widget-iframe {
    opacity: 0;
  }
}
